<template>
  <div>
    <div ref="container" :style="{ fontSize: fontSize }">
      <svg id="svg" viewBox="0 0 175 50" preserveAspectRatio="xMinYMin">
        <rect x="0" y="0" width="175" height="10" fill="#009879" />
        <text x="10" y="7" font-size="7" fill="white" font-weight="bold">
          MAP
        </text>
        <text x="60" y="7" font-size="7" fill="white" font-weight="bold">
          Duration
        </text>
        <text x="120" y="7" font-size="7" fill="white" font-weight="bold">
          Episodes (&gt;1m)
        </text>

        <rect x="0" y="10" width="175" height="10" fill="#f3f3f3" />
        <text x="10" y="17" font-size="6">&lt;75</text>
        <text x="60" y="17" font-size="6">{{ durationsStrings[0] }}</text>
        <text x="140" y="17" font-size="6">{{ episodesCount[0] }}</text>

        <rect x="0" y="20" width="175" height="10" fill="white" />
        <text x="10" y="27" font-size="6">&lt;65</text>
        <text x="65" y="27" font-size="6">{{ durationsStrings[1] }}</text>
        <text x="140" y="27" font-size="6">{{ episodesCount[1] }}</text>

        <rect x="0" y="30" width="175" height="10" fill="#f3f3f3" />
        <text x="10" y="37" font-size="6">&lt;55</text>
        <text x="65" y="37" font-size="6">{{ durationsStrings[2] }}</text>
        <text x="140" y="37" font-size="6">{{ episodesCount[2] }}</text>

        <rect x="0" y="19.5" width="175" height="1" fill="#dddddd" />
        <rect x="0" y="29.5" width="175" height="1" fill="#dddddd" />

        <rect x="0" y="40" width="175" height="2" fill="#009879" />
      </svg>
    </div>
  </div>
</template>

<script>
import { textFitMixin } from '@/components/TextFitMixin'

export default {
  name: 'HypoTable',
  mixins: [textFitMixin],
  props: {
    episodesCount: {
      type: Array
    },
    hypoSeconds: {
      type: Array
    }
  },
  computed: {
    durationsStrings() {
      return this.hypoSeconds.map(duration => {
        let hours = Math.floor(duration / 3600).toFixed(0)
        let mins = Math.round((duration % 3600) / 60).toFixed(0)
        if (hours > 0) return `${hours}h ${mins}m`
        else if (mins > 0) return `${mins}m`
        else return '0'
      })
    }
  }
}
</script>

<style scoped>
#svg {
  width: 100%;
  margin: 0;
}
</style>
